import { Terminal } from "contract/common";
import { FlightPublic } from "contract/view-collection/flight";
import { groupBy } from "ramda";

export function groupTernipFlights(flights: FlightPublic[]) {
  return groupBy(
    (item: FlightPublic) => item.turnipsFlightType || Terminal.GENERAL
  )(flights);
}
